import { gql } from '@apollo/client';
import { CORE_PAGE_INFO_FIELDS } from 'src/components/providers/apollo-provider-provider';

const DOCUMENT_SOURCE_ITEM_FIELDS_FRAGMENT = gql`
  fragment DocumentSourceItemFields on AIAgentDocumentSourceItem {
    id
    title
    size
    status
    createdAt
  }
`;

export const DOCUMENT_SOURCE_ITEMS_LIST_QUERY = gql`
  ${CORE_PAGE_INFO_FIELDS}
  ${DOCUMENT_SOURCE_ITEM_FIELDS_FRAGMENT}
  query DocumentSourceItemsList(
    $companyId: Int!
    $knowledgeBaseId: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: AIAgentDocumentSourceItemOrderByInput
  ) {
    aiAgents {
      listDocumentSourceItems(
        companyId: $companyId
        knowledgeBaseId: $knowledgeBaseId
        after: $after
        before: $before
        first: $first
        last: $last
        orderBy: $orderBy
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        nodes {
          ...DocumentSourceItemFields
        }
      }
    }
  }
`;

export const GENERATE_DOCUMENT_UPLOAD_POST_MUTATION = gql`
  mutation GenerateDocumentUploadPost(
    $input: GenerateAIAgentDocumentSourceItemUploadPostInput!
  ) {
    aiAgents {
      generateDocumentSourceItemUploadPost(input: $input) {
        url
        fields {
          key
          value
        }
      }
    }
  }
`;

export const CREATE_DOCUMENT_SOURCE_ITEM_MUTATION = gql`
  ${DOCUMENT_SOURCE_ITEM_FIELDS_FRAGMENT}
  mutation CreateDocumentSourceItem($input: CreateAIAgentDocumentSourceItemInput!) {
    aiAgents {
      createDocumentSourceItem(input: $input) {
        ...DocumentSourceItemFields
      }
    }
  }
`;

export const DELETE_DOCUMENT_SOURCE_ITEM_MUTATION = gql`
  mutation DeleteDocumentSourceItem($input: AIAgentDocumentSourceItemInput!) {
    aiAgents {
      deleteDocumentSourceItem(input: $input) {
        success
      }
    }
  }
`;
